window.scrollToAnchor = function (target) {
    scrollTo(target);
};

$('.bn_scroll-link').on('click', function (event) {
    event.preventDefault();

    scrollTo($(this).attr('href'))
});

function scrollTo(target) {
    let body = $('html, body'),
        currentTop = $(window).scrollTop(),
        scroll = $(target).offset().top - $('.bn_header').height(),
        rate = 0.5,
        distance;

    distance = Math.abs(currentTop - scroll);
    body.stop().animate({scrollTop: scroll}, distance * rate);
}